import { ChangeEvent, FC, useContext, useEffect, useState } from "react";
import { AppContext } from "../../appContext/AppContext";
import { CODE, DEFAULT_PAGE_INDEX, KEY, SELECTION_MODE, WF_TRACKER } from "../../utils/Constant";
import { Button } from "react-bootstrap";
import TextField from "../../component/TextField";
import InputSearch from "../../component/InputSearch";
import { TableCustom } from "../../component/table/table-custom/TableCustom";
import CustomIconButton from "../../component/custom-icon-button/CustomIconButton";
import { TableCustomHeader } from "../../component/table/components/TableCustomHeader";
import { TablePagination } from "../../component/table/components/TablePagination";
import { handlePagesChange, handleRowsPerPageChange, rowsForPage } from "../../utils/PageUtils";
import WfStatusSummary from "../../workflows/components/WfStatusSummary";
import { ConfirmDialog } from "../../component/ConfirmDialog";
import { toast } from "react-toastify";
import { getSummaryStatusByIdWarehouse, getSummaryStatusByType } from "../../workflows/services/WfWorkflowsService";
import { formatDateFromDTOCustom, formatDateToDTOCustom } from "../../utils/AppFunction";
import { WMS_STATUS } from "../../phan-he-nhap-kho/constants/constansNhapKho";
import { localStorageItem } from "../../utils/LocalStorage";
import { BSCoSoTuTrucColumns } from "../../phan-he-tu-truc/constants/TuTrucColumns";
import { getListLoaiPhieuTongHop, getListPhieuChiDinh } from "../services/TongHopPhieuServices";
import DialogThemMoiPhieuXuatKho from "./ThemMoiPhieuXuat/DialogThemMoiPhieuXuatKho";
import AutocompleteObjectV2 from "../../component/AutocompleteObjectV2";
import { DanhSachPhieuTongHopColumns } from "../constants/TongHopPhieuColumns";
import { getListWarehouse } from "../../utils/ServicesUtils";
import ButtonIn from "../../component/button-in-phieu";
import { HOAN_TRA_DVKT, trackerCode } from "../Constant";

type Props = {
  modelId?: any;
}

export const DanhSachPhieuTongHop: FC<Props> = (props) => {
  const { modelId } = props;
  const SITE = process.env.REACT_APP_SITE;
  const { setIsLoading } = useContext(AppContext);
  const [dsPhieuTuTruc, setDsPhieuTuTruc] = useState([]);
  const [lstWarehouse, setLstWarehouse] = useState<any>([]);
  const [warehouse, setWarehouse] = useState<any>();
  const [openDialogThemMoi, setOpenDialogThemMoi] = useState(false);
  const [openDialogConfirmDelete, setOpenDialogConfirmDelete] = useState<boolean>(false);
  const [itemSelected, setItemSelected] = useState<any>({});
  const [searchData, setSearchData] = useState<any>();
  const [rowsPerPage, setRowsPerPage] = useState<number>(20);
  const [page, setPage] = useState<number>(DEFAULT_PAGE_INDEX);
  const [summaryStatus, setSummaryStatus] = useState<any>([]);
  const [warehouseExportType, setWarehouseExportType] = useState<any>();
  const [options, setOptions] = useState<any>([]);
  const [status, setStatus] = useState(null);
  const [configTable, setConfigTable] = useState<any>({
    totalPages: 0,
    totalElements: 0,
    numberOfElements: 0,
  });

  useEffect(() => {
    updatePageData();
  }, [page, rowsPerPage, warehouse, warehouseExportType, searchData]);

  useEffect(() => {
    setSearchData({
      ...searchData,
      slipStatus: status,
    })
  }, [status]);
  useEffect(() => {
    const getList = async () => {
      try {
        setIsLoading(true);
        const { data } = await getListLoaiPhieuTongHop();
        if (CODE.SUCCESS === data.code) {
          setOptions(data.data);
          setWarehouseExportType(data.data[0])
        } else {
          toast.error('Có lỗi xảy ra, vui lòng thử lại')
        }
      } catch (error) {
        console.error(error);
      } finally {
        setIsLoading(false);
      };
    };
    getList();
  }, [])


  const updateListWarehouse = async () => {
    try {
      const data = await getListWarehouse();
      setLstWarehouse(data);
      // setWarehouse(data[0]);
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    updateListWarehouse();
  }, []);


  const handleChangeSearchData = (e: ChangeEvent<HTMLInputElement>) => {
    setSearchData({
      ...searchData,
      [e.target.name]: e.target.value,
    });
  };


  const handlerSearchKeyWorld = () => {
    setPage(DEFAULT_PAGE_INDEX);
    setRowsPerPage(20);
    updatePageData()
  }
  const updatePageData = async () => {
    if (!warehouseExportType?.code) return
    try {
      setIsLoading(true);
      const { data } = await getListPhieuChiDinh({
        // ...searchData,
        // exportDateFromDate: formatDateFromDTOCustom(searchData?.exportDateFromDate),
        // exportDateToDate: formatDateToDTOCustom(searchData?.exportDateToDate),
        // pageIndex: page,
        // pageSize: rowsPerPage,
        // type: modelId.type,
        // whIssueId: modelId.whIssueId
        slipStatus: status,
        keyword: searchData?.keyword || "",
        exportDateFromDate: formatDateFromDTOCustom(searchData?.exportDateFromDate) || null,
        exportDateToDate: formatDateToDTOCustom(searchData?.exportDateToDate) || null,
        pageSize: rowsPerPage,
        pageIndex: page,
        type: 16,
        warehouseExportType: warehouseExportType?.code,
        warehouseId: warehouse?.id
      });
      const tracker = warehouseExportType?.description || trackerCode?.issue_orders_export_summary;
      const resSummary = await getSummaryStatusByType(
        tracker,
        16,
        {
          warehouseId: warehouse?.id,
          warehouseExportType: warehouseExportType?.code,
          exportDateFromDate: formatDateFromDTOCustom(searchData?.exportDateFromDate) || null,
          exportDateToDate: formatDateToDTOCustom(searchData?.exportDateToDate) || null,
        }
      );
      CODE.SUCCESS === resSummary?.data?.code && setSummaryStatus(resSummary.data.data);
      if (CODE.SUCCESS === data.code) {
        setDsPhieuTuTruc(data?.data?.content);
        setConfigTable({
          totalPages: Math.ceil(data.data.pageable.totalElements / data.data.pageable.pageSize),
          totalElements: data.data.pageable.totalElements,
          numberOfElements: data.data.pageable.pageSize,
        });
      } else {
        toast.error('Lỗi tìm kiếm phiếu, vui lòng thử lại');
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCloseDialog = () => {
    setOpenDialogThemMoi(false);
    setOpenDialogConfirmDelete(false);
    setItemSelected({});
    updatePageData();
  };

  const handleDelete = async () => {
    // try {
    //   setIsLoading(true);
    //   const response = await deletePhieuTuTruc(itemSelected.id);
    //   if (CODE.SUCCESS === response.status) {
    //     toast.success(`Xóa ${modelId.title} thành công`);
    //     handleCloseDialog();
    //   } else {
    //     toast.error('Có lỗi xảy ra, vui lòng thử lại');
    //   }
    // } catch (error) {
    //   console.error(error);
    // } finally {
    //   setIsLoading(false);
    // }
  };

  const handleChangeSelect = (data: any) => {
    setWarehouseExportType(data);
    setSearchData({})
  };

  const handleChangeSelectWarehouse = (data: any) => {
    setWarehouse(data);
    setSearchData({})
  };



  const columnsActions = {
    Header: (props: any) => (
      <TableCustomHeader<any>
        tableProps={props}
        title={"Thao tác"}
        className='text-center text-light spaces w-80px'
      />
    ),
    id: 'actions',
    Cell: ({ ...props }) => {
      return (
        (
          <div className="d-flex justify-content-center gap-3">
            <CustomIconButton
              variant="edit"
              onClick={() => {
                setItemSelected(props.cell.row.original);
                setOpenDialogThemMoi(true);
              }}
            >
              <i className={`spaces bi bi-pencil-square text-navy ${(props.cell.row.original?.statusCode !== WMS_STATUS.warehouse_new && modelId.title) ? 'mx-0' : 'mr-5'}`}></i>
            </CustomIconButton>
            <ButtonIn
              isIcon
              endpoint="api/download/summary-slip"
              params={{
                slipId: props.cell.row.original?.id,
                name: props.cell.row.original?.name
              }}
            />
          </div>
        )
      )
    }
  };

  const onClickStatus = (item: any) => {
    setStatus(() => item?.statusCode === status ? null : item?.statusCode)
  }

  return (
    <div className="bg-white h-100">
      <div className="flex-1 flex flex-column">
        <div className="d-flex bg-gray ">
          <div className="spaces width-100 bg-gray radius-2">
            <div className="flex bg-white spaces width-100 justify-content-between" >
              <div className="flex bg-white spaces width-100" >
                <h4 className="text-title text-pri fw-bold fs-4 spaces mb-0  px-10">
                  {`Danh sách ${modelId.title}`}
                </h4>
                <div className="flex bg-white spaces width-20 mt-2 ml-12" >
                  <AutocompleteObjectV2
                    options={[...options]}
                    isSearchDefauilt={true}
                    name={"WmsCode"}
                    onChange={(options: any) => handleChangeSelect(options)}
                    value={warehouseExportType || ""}
                    className="autocomplete-custom-renderform  radius spaces width-100 h-29"
                    isClearable={false}
                  />
                </div>
              </div>
            </div>
            <div className="d-flex mt-1 flex-column spaces width-100">
              <div className="bg-white">
                <div className="d-flex spaces pr-8 mt-6 bg-white justify-content-between align-items-center mb-6">
                  <h4 className=" fs-4 spaces mb-0  px-5">
                    {`Kho`}
                  </h4>
                  <div className="flex bg-white spaces width-20  ml-5" >
                    <AutocompleteObjectV2
                      options={lstWarehouse}
                      isSearchDefauilt={true}
                      name={"WmsCode"}
                      onChange={(options: any) => handleChangeSelectWarehouse(options)}
                      value={warehouse || ""}
                      className="autocomplete-custom-renderform  radius spaces width-100 h-29"
                      isClearable={true}
                    />
                  </div>
                  <div className="d-flex spaces mx-10 ">
                    <TextField
                      label="Từ ngày"
                      name="exportDateFromDate"
                      type="date"
                      value={searchData?.exportDateFromDate || ''}
                      className="flex"
                      labelClassName="spaces mt-5 mr-5"
                      onChange={handleChangeSearchData}
                    />
                  </div>
                  <div className="d-flex spaces mr-10">
                    <TextField
                      label="Đến ngày"
                      name="exportDateToDate"
                      type="date"
                      className="flex"
                      value={searchData?.exportDateToDate || ''}
                      labelClassName="spaces mt-5 mr-5"
                      onChange={handleChangeSearchData}
                    />
                  </div>
                  <div className="flex-grow-1 ">
                    <InputSearch
                      name="keyword"
                      value={searchData?.keyword || ''}
                      placeholder="Tìm kiếm"
                      handleChange={handleChangeSearchData}
                      handleSearch={handlerSearchKeyWorld}
                      handleKeyDown={(e: React.KeyboardEvent) => e.key === KEY.ENTER && handlerSearchKeyWorld()}
                      className="spaces h-31 pr-4  radius-3"
                    />
                  </div>
                </div>
                <div className=" spaces bg-white mb-0">
                  <TableCustom<any>
                    className="spaces table-xuat-thuoc h-calc-vh-250"
                    data={dsPhieuTuTruc}
                    columns={DanhSachPhieuTongHopColumns}
                    columnsActions={columnsActions}
                    verticalScroll={true}
                  // selectionMode={SELECTION_MODE.MULTI}
                  />
                  <TablePagination
                    handlePagesChange={handlePagesChange}
                    handleRowsPerPageChange={handleRowsPerPageChange}
                    rowsPerPage={rowsPerPage}
                    rowsForPage={rowsForPage}
                    page={page}
                    setPage={setPage}
                    setRowsPerPage={setRowsPerPage}
                    totalPages={configTable.totalPages}
                    totalElements={configTable.totalElements}
                    numberOfElements={configTable.numberOfElements}
                    hideTotalElements
                    customComponent={<WfStatusSummary summaryStatus={summaryStatus} col={2} noWrap onClick={onClickStatus} activeStatus={status}/>}
                    customComponentClassName="min-w-1100"
                    className="border border-0"
                  />
                </div>
              </div>
            </div>
          </div>

          {openDialogThemMoi &&
            <DialogThemMoiPhieuXuatKho
              type={16}
              MATE_WH_DEFAUILT={[]}
              warehouseExportType={{
                modelId: "tonghopduyetphieutonghop",
                modelIdVT: "formThemMoiVatTuXuatKho",
                code: warehouseExportType?.code,
                description: warehouseExportType?.description,
              }}
              title="Phiếu tổng hợp"
              show={openDialogThemMoi}
              onHide={handleCloseDialog}
              dataEdit={itemSelected}
              warehouseId={92}
            />
          }
          {openDialogConfirmDelete &&
            <ConfirmDialog
              show={openDialogConfirmDelete}
              onCloseClick={handleCloseDialog}
              onYesClick={handleDelete}
              title="Xóa phiếu"
              message={`Bạn chắc chắn muốn xóa phiếu: ${itemSelected.code} ?`}
              yes="Xóa"
              close="Hủy"
            />
          }
        </div>
      </div>
    </div>
  );
};

export default DanhSachPhieuTongHop;
